import React from 'react';
import { Plane, Hotel, Tent } from 'lucide-react';
import { MovementType } from '../../../types/movement';
import { useLanguage } from '../../../contexts/LanguageContext';

type Props = {
  type: MovementType;
};

export const MovementTypeBadge = ({ type }: Props) => {
  const { translations } = useLanguage();

  const config = {
    arrival: {
      icon: Plane,
      text: translations?.movementTypes?.arrival || 'Arrival',
      colors: 'bg-blue-50 text-blue-700'
    },
    departure: {
      icon: Plane,
      text: translations?.movementTypes?.departure || 'Departure',
      colors: 'bg-purple-50 text-purple-700'
    },
    hotel_transfer: {
      icon: Hotel,
      text: translations?.movementTypes?.hotelTransfer || 'Hotel Transfer',
      colors: 'bg-green-50 text-green-700'
    },
    camp_departure: {
      icon: Tent,
      text: translations?.movementTypes?.campDeparture || 'Camp Departure',
      colors: 'bg-amber-50 text-amber-700'
    },
    camp_return: {
      icon: Tent,
      text: translations?.movementTypes?.campReturn || 'Camp Return',
      colors: 'bg-orange-50 text-orange-700'
    },
    hotel_transfer_madinah: {
      icon: Hotel,
      text: translations?.movementTypes?.hotelTransferMadinah || 'Transfer to Madinah',
      colors: 'bg-emerald-50 text-emerald-700'
    }
  };

  const { icon: Icon, text, colors } = config[type];

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-medium ${colors}`}>
      <Icon size={14} />
      {text}
    </span>
  );
};

